import { usePreviewContext } from '../../context';
import { PropsWithChildren } from 'react';
import ReactDOM from 'react-dom';

const PreviewCardActive = (props: PropsWithChildren<{ id: string }>) => {
  const context = usePreviewContext();
  const onMouseLeave = () => {
    context.setActiveElement({
      id: null,
      target: null,
    });
  };
  if (props.id !== context.activeElement.id) return null;
  return ReactDOM.createPortal(<div onMouseLeave={onMouseLeave}>{props.children}</div>, context.portalRef);
};

export default PreviewCardActive;
